import { render, staticRenderFns } from "./PendingInfo.vue?vue&type=template&id=1609972c"
import script from "./PendingInfo.vue?vue&type=script&lang=js"
export * from "./PendingInfo.vue?vue&type=script&lang=js"
import style0 from "./PendingInfo.vue?vue&type=style&index=0&id=1609972c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports